import styled from 'styled-components'

interface InputFileWrapperProps {
  invalid?: boolean
}

export const InputFileWrapper = styled.div<InputFileWrapperProps>`
  align-items: center;
  display: flex;
  background-color: #e9ecef;
  border-radius: 15px;
  border: solid 1px ${(props) => (props.invalid ? `#dc3545` : '#ced4da')};
  height: 38px;
  justify-content: center;
  padding: 6px 12px;
  white-space: nowrap;
  width: 100%;

  & span {
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
  }

  &:hover {
    background-color: #dde0e3;
  }
`
export const TabelaComScroll = styled.div`
  width: 100%;
  overflow-x: auto;

  .MuiDataGrid-root {
    min-width: 1200px;
  }
`
